import React, { Component } from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import MealBox from "../components/mealBox";
import { withRouter } from "../utils/withRouter";
import Meals from "../models/meals-model";
import Cart from "../models/cart-model";
import SignalDispatcher from "../utils/signalDispatcher";
import CommonService from "../services/common.service";
import config from "../config.json";
import axios from "axios";
import userEventService from "../services/user-event.service";

let common = new CommonService();

interface DetailsPageProps {
    params: {
        service: string;
        prodid: string;
        eventid: string;
        date: string;
        time: string;
        maxnum: string;
    };
}

interface DetailsState {
    service: string;
    event_id: string;
    id: string;
    available: number;
    maxNum: number;
    title: string;
    description: string;
    image: string;
    price?: any;
    ticketCount?: number;
    toChooseMeals?: number;
    mealsList?: Array<Meals>;
    selectedMeals?: Array<Meals>;
    date: string;
    time: string;
    translations: Record<string, any>;
}

class Details extends Component<DetailsPageProps, DetailsState> {
    constructor(props: DetailsPageProps) {
        super(props);
        this.state = { 
            service: this.props.params.service,
            event_id: this.props.params.eventid,
            id: this.props.params.prodid,
            available: 0,
            maxNum: parseInt(this.props.params.maxnum) || 0,
            title: "",
            description: "",
            image: "",
            ticketCount: 0,
            toChooseMeals: 0,
            mealsList: [],
            date: this.props.params.date,
            time: this.props.params.time,
            translations: JSON.parse(localStorage.getItem('translations') || '[]')
        };
    }

    componentDidMount(): void {
        userEventService.sendEvent('page_view', 'details_page_open', {
            service: this.state.service,
            productId: this.state.id,
            eventId: this.state.event_id,
            date: this.state.date,
            time: this.state.time
        });
        if (this.state.event_id && this.state.id) {
            common.getMenus(this.state.event_id).then((res) => {
                if (res) {
                    const menus = res.map((menu: any) => ({id: menu.parent_menu, title: menu.box_title, description: menu.box_subtitle, image: config.PATH + menu.images[0].image_content, price_huf: parseInt(menu.parent_price)}));
                    this.setState({
                        available: 30,
                        mealsList: menus
                    });
                }
            });
        }
    }

    private navigatePage(url: string) {
        window.location.href = url;
    }

    private isMaxReached(): boolean {
        return this.state.maxNum > 0 && (this.state.ticketCount ? this.state.ticketCount : 0) >= this.state.maxNum;
    }

    private incrementTickets() {
        if (this.isMaxReached()) {
            return;
        }
        this.setState({ ticketCount: (this.state.ticketCount ? this.state.ticketCount : 0) + 1 });
        this.setState({ toChooseMeals: (this.state.toChooseMeals ? this.state.toChooseMeals : 0) + 1 });
    }

    private decrementTickets() {
        this.setState({ ticketCount: (this.state.ticketCount && this.state.ticketCount > 0) ? this.state.ticketCount - 1 : 0 });
        this.setState({ toChooseMeals: (this.state.toChooseMeals && this.state.toChooseMeals > 0) ? this.state.toChooseMeals - 1 : 0 });
    }

    mealIncrement = (mealData: Meals) => {
        if (this.isMaxReached()) {
            return;
        }
        this.state.selectedMeals?.find((meal) => meal.id === mealData.id) ?
        this.setState({
            selectedMeals: this.state.selectedMeals?.map((meal) =>
                meal.id === mealData.id ? { ...meal, quantity: (meal.quantity ? meal.quantity : 0) + 1 } : meal
            )
        })
        :
        this.setState({
            selectedMeals: this.state.selectedMeals ? [...this.state.selectedMeals, { ...mealData, quantity: 1 }] : [{ ...mealData, quantity: 1 }]
        });

        this.setState({ toChooseMeals: (this.state.ticketCount && this.state.toChooseMeals && this.state.toChooseMeals > 0) ? this.state.toChooseMeals - 1 : 0 });
        this.incrementTickets();
    }

    mealDecrement = (mealData: Meals) => {
        this.state.selectedMeals?.find((meal) => meal.id === mealData.id && meal.quantity && meal.quantity > 0) &&
        this.setState({
            selectedMeals: this.state.selectedMeals?.map((meal) =>
                meal.id === mealData.id ? { ...meal, quantity: (meal.quantity ? meal.quantity : 0) - 1 } : meal
            ).filter((meal) => meal.quantity && meal.quantity > 0)
        });

        this.setState({ toChooseMeals: (this.state.toChooseMeals ? this.state.toChooseMeals : 0) + 1 });
        this.decrementTickets();
    }

    validateForCart() {
        return this.state.ticketCount === 0 ? true : false;
    }

    private addToCart() {
        let cartData = localStorage.getItem('cart');
        if (!cartData) {
            let initialCart: Cart;
            const totalMealsPrice = this.state.selectedMeals?.reduce((total, meal) => total + ((meal.price_huf ? meal.price_huf : 0) * (meal.quantity ? meal.quantity : 0)), 0);
            initialCart = {
                cartId: Math.floor(Math.random() * 1000000),
                events: [
                    {
                        id: this.state.id, 
                        name: this.state.service, 
                        date: this.state.date,
                        time: this.state.time,
                        quantity: this.state.ticketCount, 
                        price: this.state.price,
                        mealsList: this.state.selectedMeals ? this.state.selectedMeals : []
                    }
                ],
                currency: 'HUF',
                totalPrice: totalMealsPrice,
                uuid: localStorage.getItem('uuid') ? localStorage.getItem('uuid') : ''
            };
            localStorage.setItem('cart', JSON.stringify(initialCart));
            const data = {
                uuid: localStorage.getItem('uuid') ? localStorage.getItem('uuid') : '', 
                event_id: this.state.id, 
                qty: this.state.ticketCount ? this.state.ticketCount : 0
            };
    
            axios.post(config.API + '/frontendReserve', data, {headers: {'Content-Type': 'application/json'}}).then(response => {
                if (response.data) {
                    localStorage.setItem('cartExpiryTime', response.data.data.timer.toString());
                    SignalDispatcher.emit('addToCart', initialCart);
                    this.navigatePage(response.data.redirect);
                }
            }).catch(error => {
                console.error('Error calling resevation:', error);
            });    
        }
        else {
            let existingCart: Cart = JSON.parse(cartData);
            existingCart.uuid = localStorage.getItem('uuid') ? localStorage.getItem('uuid') : '';
            if (existingCart.events) {
                const eventIndex = existingCart.events.findIndex(event => event.id === this.state.id);
                if (eventIndex > -1) {
                    existingCart.events[eventIndex].quantity = (existingCart.events[eventIndex].quantity ? existingCart.events[eventIndex].quantity : 0) + (this.state.ticketCount ? this.state.ticketCount : 0);
                    if (this.state.selectedMeals) {
                        if (existingCart.events[eventIndex].mealsList && existingCart.events[eventIndex].mealsList !== undefined) {
                            existingCart.events[eventIndex].mealsList = existingCart.events[eventIndex].mealsList?.concat(this.state.selectedMeals);
                        } else {
                            existingCart.events[eventIndex].mealsList = this.state.selectedMeals;
                        }
                    }
                } else {
                    existingCart.events.push({
                        id: this.state.id, 
                        name: this.state.service, 
                        date: new Date().toISOString().split('T')[0],
                        time: new Date().toISOString().split('T')[1].split('.')[0],
                        quantity: this.state.ticketCount, 
                        price: this.state.price,
                        mealsList: this.state.selectedMeals ? this.state.selectedMeals : []
                    });
                }
            }
            else {
                existingCart.events = [
                    {
                        id: this.state.id, 
                        name: this.state.service, 
                        date: new Date().toISOString().split('T')[0],
                        time: new Date().toISOString().split('T')[1].split('.')[0],
                        quantity: this.state.ticketCount, 
                        price: this.state.price,
                        mealsList: this.state.selectedMeals ? this.state.selectedMeals : []
                    }
                ];
            }
            localStorage.setItem('cart', JSON.stringify(existingCart));
            const data = {
                uuid: localStorage.getItem('uuid') ? localStorage.getItem('uuid') : '', 
                event_id: this.state.id, 
                qty: this.state.ticketCount ? this.state.ticketCount : 0
            };
    
            axios.post(config.API + '/frontendReserve', data, {headers: {'Content-Type': 'application/json'}}).then(response => {
                if (response.data) {
                    localStorage.setItem('cartExpiryTime', response.data.data.timer.toString());
                    SignalDispatcher.emit('addToCart', existingCart);
                    this.navigatePage(response.data.redirect);
                }
            }).catch(error => {
                console.error('Error calling resevation:', error);
            });
        }
    }

    yeah() {
        console.log('Yeah!');
    }

    render() {
        return (
            <Container className="oc-products">
                <Row key={1} className="oc-page-title">
                    <Col lg={12} md={12} sm={12} xs={12}>
                        <h2>{this.state.translations.filter((item: any) => item.setting_name === 'DETAILS_OF_YOUR_RESERVATION')[0].setting_value_text}</h2>
                    </Col>
                </Row>
                <Row key={2} className="oc-bordered">
                    <Col lg={9} md={12} sm={12} xs={12}>
                        <strong className="oc-number-of-tickets-label">{this.state.translations.filter((item: any) => item.setting_name === 'NUMBER_OF_TICKETS')[0].setting_value_text}</strong>
                        { this.state.maxNum > 0 &&
                        <span className="oc-max-tickets-label">
                            {(localStorage.getItem('language') || 'en') === 'hu'
                                ? `Maximum ${this.state.maxNum} jegy foglalható.`
                                : `A maximum of ${this.state.maxNum} tickets can be booked.`}
                        </span>
                        }
                    </Col>
                    <Col lg={3} md={4} sm={4} xs={4}>
                        <input type="text" className="oc-input oc-input-count" value={this.state.ticketCount} readOnly />
                    </Col>
                </Row>
                { this.state.service !== 'privateboat' &&
                <Row key={3} className="oc-details-info">
                    <p>{this.state.translations.filter((item: any) => item.setting_name === 'WELCOME_DRINK')[0].setting_value_text}</p>
                    <p>{this.state.translations.filter((item: any) => item.setting_name === 'BAR_TEXT')[0].setting_value_text}</p>
                </Row>
                }
                <Row key={4} className="oc-details-actions">
                    <Col lg={12} md={12} sm={12} xs={12}>
                        <Button className="oc-btn-alert" disabled={this.validateForCart()} onClick={() => this.addToCart()}>{this.state.translations.filter((item: any) => item.setting_name === 'PROCEED_TO_CHECKOUT')[0].setting_value_text}</Button>
                    </Col>
                </Row>
                <Row key={5}>
                    {this.state.mealsList?.map((meal, index) => (
                        <Col key={index} lg={6} md={12} sm={12} xs={12}>
                            <MealBox mealData={meal} maxCounter={this.state.toChooseMeals} maxReached={this.isMaxReached()} onMealCountIncremented={this.mealIncrement} onMealCountDecremented={this.mealDecrement}></MealBox>
                        </Col>
                    ))}
                </Row>
                <Row key={6}>
                    <Col lg={6} md={6} sm={6} xs={6} className="oc-text-left">
                        <Button className="oc-btn-default" onClick={() => this.navigatePage(`/products/${this.state.service}`)}>{this.state.translations.filter((item: any) => item.setting_name === 'BACK')[0].setting_value_text}</Button>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={6} className="oc-text-right">
                        <Button className="oc-btn-alert" disabled={this.validateForCart()} onClick={() => this.addToCart()}>{this.state.translations.filter((item: any) => item.setting_name === 'PROCEED_TO_CHECKOUT')[0].setting_value_text}</Button>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default withRouter(Details);